import glam from 'glamorous';
import React from 'react';
import { Colors, LocalizedText } from 'module/View/Common';
import { connect } from 'react-redux';
import { createPureComponent } from 'module/Common';
import { Localized } from 'module/Model/Localized';
import { MenuAction } from 'module/Redux/Menu';
import { MenuItemNewsletter } from 'module/Model/Menu';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { State } from 'module/Redux';

const Wrapper = glam.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.4rem 0.4rem 0 0',
  fontSize: '1.2rem',
});

const Link = glam.a({
  color: Colors.black,
  '&:hover': {
    color: '#25378b',
  },
});

type StateProps = {};

const mapStateToProps = (state: State): StateProps => ({});

type DispatchProps = {
  closeMenu: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  closeMenu: () => dispatch(MenuAction.setClose()),
});

type OwnProps = {
  item: MenuItemNewsletter;
};

type Props = StateProps & DispatchProps & OwnProps;

const ItemNewsletterComp = createPureComponent<Props>('ItemNewsletter', ({ item }) => {
  return (
    <Wrapper>
      <Link href={MenuItemNewsletter.getLink(item)} target="_blank">
        <LocalizedText content={Localized.create(`S'inscrire à la newsletter`, 'Subscribe to our newsletter')} />
      </Link>
    </Wrapper>
  );
});

export const ItemNewsletter = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemNewsletterComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/ItemNewsletter.tsx